"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
class ClickedOutside extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.targetRef = react_1.default.createRef();
        this.handleClick = (event) => {
            const target = event.target;
            if (this.targetRef.current &&
                !this.targetRef.current.contains(target) &&
                this.props.shouldHandleClick) {
                this.props.onClickOutside();
            }
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClick);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick);
    }
    render() {
        const { children } = this.props;
        if (!children) {
            return null;
        }
        return children({ ref: this.targetRef });
    }
}
exports.default = ClickedOutside;
